module.exports = __webpack_public_path__ + "static/hp_sponsors_lordTavernes-a237ebe23f3ac712e034b8d8e5508f62.jpg";